/*
 * @Author: Michael
 * @Date: 2018-09-18 15:28:00
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-08-19 10:34:33
 */
import CONFIG from '@/common/config';
import fetch from '@/common/api/fetch';
import getUrlParam from '@/common/utils/getUrlParam';
import getActivityType from '@/common/utils/getActivityType';
import { SelectBGMState, AxiosPromiseData } from '@/common/interface';
import { Ladder } from '@/common/interface/group_type';

const actions = {
  // 再编辑更新抽奖品列表
  updatePrizeList({ commit }: any, list: Array<any>) {
    commit('UPDATE_PRIZE_PICTURE_LIST', list);
  },
  // 设置抽奖次数
  changeTotalTimesStatus({ commit }: any) {
    commit('CHANGE_TOTALTIMES_STATUS');
  },
  // 设置抽奖次数
  changeDayTimesStatus({ commit }: any) {
    commit('CHANGE_DAYTIMES_STATUS');
  },
  // 删除抽奖品列表上传图片
  handleDeletePrizeImg({ commit }: any, index: number) {
    commit('HANDLE_DELETE_PRIZE_IMG', index);
  },
  // 更改抽奖品列表上传图片
  changePrizeItem({ commit }: any, item: object) {
    commit('CHANGE_PRIZE_ITEM', item);
  },
  // 更改抽奖品列表数量
  changeSubtractPrizeLength({ commit }: any, val: boolean) {
    commit('CHANGE_SUBTRACT_PRIZE_LENGTH', val);
  },
  // 减少购课人数
  changeSubtractLimitBuyerNum({ commit }: any, val: boolean) {
    commit('CHANGE_SUBTRACT_LIMITBUYER_NUM', val);
  },
  // 增加抽奖品列表
  addPrizePicture({ commit }: any, item: object) {
    commit('ADD_PRIZE_PICTURE', item);
  },
  // 改变抽奖品列表
  handleDeletePrizeProListItem({ commit }: any, itemIndex: number) {
    commit('HANDLED_ELETEPRIZE_PROLIST_ITEM', itemIndex);
  },
  // 改变扭蛋机的活动类型
  toggleGachaType({ commit }: any, targetType: string) {
    commit('TOGGLE_GACHA_TYPE', targetType);
    commit('TOGGLE_PLAY_TYPE', targetType);
  },
  // 改变扭蛋机的玩法说明类型
  togglePlayType({ commit }: any, targetType: string) {
    commit('TOGGLE_PLAY_TYPE', targetType);
  },
  changeXcxFlag({ commit }: any): void {
    commit('CHANGE_XCXFLAG');
  },

  changeIsInvalid({ commit }: any, payload: any): void {
    commit('CHANGE_ISINVALID', payload);
  },
  changeIsAgain({ commit }: any, payload: any): void {
    commit('CHANGE_ISAGAIN', payload);
  },
  changeOpenId({ commit }: any, payload: any): void {
    commit('CHANGE_OPENID', payload);
  },
  changeUid({ commit }: any, payload: any): void {
    commit('CHANGE_UID', payload);
  },
  changeJoinInfo({ commit }: any, payload: any): void {
    commit('CHANGE_JOIN_INFO', payload);
  },
  changeSignature({ commit }: any, payload: any): void {
    commit('CHANGE_SIGNATURE', payload);
  },
  changeTitle({ commit }: any, payload: any): void {
    commit('CHANGE_TITLE', payload);
  },
  changeDeadline({ commit }: any, payload: any): void {
    commit('CHANGE_DEADLINE', payload);
  },
  changeStartTime({ commit }: any, payload: any): void {
    commit('CHANGE_STARTTIME', payload);
  },
  changeInstName({ commit }: any, payload: any): void {
    commit('CHANGE_INSTNAME', payload);
  },
  changeInstAddress({ commit }: any, payload: any): void {
    commit('CHANGE_INST_ADDRESS', payload);
  },
  changeWechatMiniOnlineStatus({ commit }: any, payload: any): void {
    commit('CHANGE_WECHAT_ONLINE_STATUS', payload);
  },
  changeXmPayRegisterStatusEnum({ commit }: any, payload: any): void {
    commit('CHANGE_XMPAY_STATUS', payload);
  },
  // 获取BGM列表
  getBGMList({ commit }: any): void {
    fetch.post('c/xm/show/bgm', {}).then((res: AxiosPromiseData) => {
      const defaultBgmItem: SelectBGMState = {
        id: 0,
        category: '默认',
        name: '无背景音乐',
        url: ''
      };
      const bgmList = res.data;
      bgmList.unshift(defaultBgmItem);
      const payload = {
        bgmList
      };
      commit('GET_BGM_LIST', payload);
    });
  },

  //获取自定义BGM列表
  getCustomizeBGMList({ commit }: any) {
    const instId = getUrlParam('instId');
    const broadcastId = getUrlParam('broadcastId');
    if (instId) {
      return fetch.Sales('anon/businessShow/getCustomizeBgmList', { instId }).then((res: AxiosPromiseData) => {
        const customizeBgmList = res.result;
        const payload = {
          customizeBgmList
        };
        commit('GET_CUSTOMIZE_BGM_LIST', payload);
      });
    } else {
      return fetch.Sales('anon/businessShow/getCustomizeBgmList', { broadcastId }).then((res: AxiosPromiseData) => {
        const customizeBgmList = res.result;
        const payload = {
          customizeBgmList
        };
        commit('GET_CUSTOMIZE_BGM_LIST', payload);
      });
    }
  },

  // 修改选择的音乐
  changeSelectBGM({ commit }: any, payload: any): void {
    commit('CHANGE_SELECTED_BGM', payload);
  },

  // 修改机构电话
  changeInstPhone({ commit }: any, payload: any): void {
    commit('CHANGE_INST_PHONE', payload);
  },

  // 切换限制报名人数开关
  switchLimitNumber({ commit }: any, payload: any): void {
    commit('SWITCH_LIMIT_NUMBER', payload);
  },

  // 修改限制的报名人数
  changeLimitNumber({ commit }: any, payload: any): void {
    commit('CHANGE_LIMIT_NUMBER', payload);
  },

  // 切换支付开关
  switchCanPay({ commit }: any, payload: any): void {
    commit('SWITCH_CAN_PAY', payload);
  },

  // 切换是否要到底价才能支付
  switchMustMinPay({ commit }: any, mustMinPay: boolean): void {
    commit('SWITCH_MUST_MIN_PAY', mustMinPay);
  },

  // 切换支付类型
  changePayType({ commit }: any, payload: any): void {
    commit('CHANGE_PAY_TYPE', payload);
  },

  // 修改支付金额
  changePayNumber({ commit }: any, payload: any): void {
    commit('CHANGE_PAY_NUMBER', payload);
  },

  // 切换是够开启虚拟成团
  changeVirtualGroup({ commit }: any, status: boolean): void {
    commit('CHANGE_VIRTUAL_GROUP', status);
  },

  /***** 活动说明 *****/
  // 修改活动规则
  changeActivityRule({ commit }: any, payload: any): void {
    commit('CHANGE_ACTIVITY_RULE', payload);
  },
  // 修改活动规则（新富文本）
  changeActivityIntros({ commit }: any, payload: any): void {
    commit('CHANGE_ACTIVITY_INTROS', payload);
  },
  // 添加
  addActivityIntros({ commit }: any, payload: any): void {
    commit('ADD_ACTIVITY_INTROS', payload);
  },
  // 删除
  deleteActivityIntro({ commit }: any, index: number): void {
    commit('REMOVE_ACTIVITY_INTROS', index);
  },
  // 上移
  upActivityIntro({ commit }: any, index: number): void {
    commit('UP_ACTIVITY_INTROS', index);
  },
  // 下移
  downActivityIntro({ commit }: any, index: number): void {
    commit('DOWN_ACTIVITY_INTROS', index);
  },
  // 替换
  replaceActivityIntros({ commit }: any, payload: any): void {
    commit('REPLACE_ACTIVITY_INTROS', payload);
  },

  /***** ***** *****/

  // 修改活动规则标题
  changeActivityTitle({ commit }: any, status: string): void {
    commit('CHANGE_ACTIVITY_TITLE', status);
  },
  // 修改活动规则开关
  changeActivitySwitch({ commit }: any, status: boolean): void {
    commit('CHANGE_ACTIVITY_SWITCH', status);
  },
  // 修改联系方式
  changeContactInfo({ commit }: any, payload: any): void {
    commit('CHANGE_CONTACT_INFO', payload);
  },
  // 修改联系方式标题
  changeContactTitle({ commit }: any, status: string): void {
    commit('CHANGE_CONTACT_TITLE', status);
  },
  // 修改联系方式开关
  changeContactSwitch({ commit }: any, status: boolean): void {
    commit('CHANGE_CONTACT_SWITCH', status);
  },
  // 修改机构介绍
  changeInstitutionIntros({ commit }: any, payload: any): void {
    commit('CHANGE_INSTITUTION_INTROS', payload);
  },
  // 修改机构介绍标题
  changeInstitutionTitle({ commit }: any, status: string): void {
    commit('CHANGE_INSTITUTION_TITLE', status);
  },
  // 修改机构介绍开关
  changeInstitutionSwitch({ commit }: any, status: boolean): void {
    commit('CHANGE_INSTITUTION_SWITCH', status);
  },

  // 修改机构简介
  changeCourseDesc({ commit }: any, payload: any): void {
    commit('CHANGE_COURSE_DESC', payload);
  },

  // 添加一个课程描述
  addCourseDesc({ commit }: any, payload: any): void {
    commit('ADD_COURSE_DESC', payload);
  },

  // 删除一个课程描述
  deleteCourseDesc({ commit }: any, index: number): void {
    commit('REMOVE_COURSE_DESC', index);
  },

  // 上移一个课程描述
  upCourseDesc({ commit }: any, index: number): void {
    commit('UP_COURSE_DESC', index);
  },

  // 下移一个课程描述
  downCourseDesc({ commit }: any, index: number): void {
    commit('DOWN_COURSE_DESC', index);
  },

  // 添加一个机构简介
  addInstitutionintro({ commit }: any, payload: any): void {
    commit('ADD_INSTITUTION_INTROS', payload);
  },
  // 删除一个机构简介
  deleteInstitutionIntro({ commit }: any, index: number): void {
    commit('REMOVE_INSTITUTION_INTROS', index);
  },
  // 上移一个机构简介
  upInstitutionIntro({ commit }: any, index: number): void {
    commit('UP_INSTITUTION_INTROS', index);
  },
  // 下移一个机构简介
  downInstitutionIntro({ commit }: any, index: number): void {
    commit('DOWN_INSTITUTION_INTROS', index);
  },

  // 获取配置信息
  getConifgState({ commit }: any, payload: any) {
    commit('UPDATE_CONFIG_STATE', payload);
  },

  // 获取活动详情
  getDetailData({ commit }: any, payload: any) {
    commit('UPDATE_DETAIL_DATA', payload);
  },
  // 获取活动详情
  getGachaTypeParameter({ commit }: any, payload: any) {
    commit('UPDATE_GACHATYPE_PARAMETER', payload);
  },

  // 修改分享图标
  changeCoverTiny({ commit }: any, shareCover: string) {
    commit('CHANGE_COVER_TINY', shareCover);
  },

  changeLimitFlag({ commit }: any, payload: any) {
    commit('CHANGE_LIMIT_FLAG', payload.limitFlag);
    commit('CHANGE_LIMIT_FLAG_NUMBER', payload.limitFlagNumber);
  },

  // 修改发布状态
  changeReleaseStatus({ commit }: any, payload: any) {
    commit('CHANGE_RELEASE_STATUS', payload);
  },
  // 修改参加人数
  changeJoinNumber({ commit }: any, joinNumber: number) {
    commit('CHANGE_JOIN_NUMBER', joinNumber);
  },

  changeScanNumber({ commit }: any, scanNumber: number) {
    commit('CHANGE_SCAN_NUMBER', scanNumber);
  },
  //获取版本
  changeShowExtId({ commit }: any, showExtId: string) {
    commit('CHANGE_EXT_ID', showExtId);
  },
  // 修改分销参数
  changeDistributeParameter({ commit }: any, payload: any) {
    commit('CHANGE_DISTRIBUTE_PARAMETER', payload);
  },
  // 修改扭蛋机参数
  changeGachaParameter({ commit }: any, payload: any) {
    commit('CHANGE_GACHA_PARAMETER', payload);
  },
  // 修改砍价参数
  changeBargainParameter({ commit }: any, payload: any) {
    commit('CHANGE_BARGAIN_PARAMETER', payload);
  },

  // 修改集赞参数
  changeTyTypeParameter({ commit }: any, payload: any) {
    commit('CHANGE_TYTYPE_PARAMETER', payload);
  },
  // 是否支付类型
  changeSupportPay({ commit }: any, payload: any) {
    commit('CHANGE_SUPPORT_PAY', payload);
  },
  // 修改支付类型: XM_CASHIER 小麦收银
  changeChannel({ commit }: any, payload: any) {
    commit('CHANGE_XM_PAY', payload);
  },
  /********* section **********/
  // 修改section里的信息
  changeSectionInfo({ commit }: any, payload: any) {
    commit('CHANGE_SECTION_INFO', payload);
  },
  // 修改section里prizeIntros信息
  changeSectionPrizeIntros({ commit }: any, payload: any) {
    commit('CHANGE_PRIZE_INTROS', payload);
  },
  addSectionPrizeIntros({ commit }: any, payload: any) {
    commit('ADD_PRIZE_INTROS', payload);
  },
  deleteSectionPrizeIntros({ commit }: any, payload: any) {
    commit('REMOVE_PRIZE_INTROS', payload);
  },
  upSectionPrizeIntros({ commit }: any, payload: any) {
    commit('UP_PRIZE_INTROS', payload);
  },
  downSectionPrizeIntros({ commit }: any, payload: any) {
    commit('DOWN_PRIZE_INTROS', payload);
  },
  // 修改section里courseIntros信息
  changeSectionCourseIntros({ commit }: any, payload: any) {
    commit('CHANGE_COURSE_INTROS', payload);
  },
  addSectionCourseIntros({ commit }: any, payload: any) {
    commit('ADD_COURSE_INTROS', payload);
  },

  deleteSectionCourseIntros({ commit }: any, payload: any) {
    commit('REMOVE_COURSE_INTROS', payload);
  },
  upSectionCourseIntros({ commit }: any, payload: any) {
    commit('UP_COURSE_INTROS', payload);
  },
  downSectionCourseIntros({ commit }: any, payload: any) {
    commit('DOWN_COURSE_INTROS', payload);
  },
  changeSectionCourseType({ commit }: any, status: string) {
    commit('CHANGE_COURSE_TYPE', status);
  },
  /********* ********** **********/

  /********* 多课程 **********/
  addSectionCourseGroupIntros({ commit }: any, payload: any) {
    commit('ADD_COURSE_GROUP_INTROS', payload);
  },
  downSectionCourseGroupIntros({ commit }: any, payload: any) {
    commit('DOWN_COURSE_GROUP_INTROS', payload);
  },
  upSectionCourseGroupIntros({ commit }: any, payload: any) {
    commit('UP_COURSE_GROUP_INTROS', payload);
  },
  deleteSectionCourseGroupIntros({ commit }: any, payload: any) {
    commit('REMOVE_COURSE_GROUP_INTROS', payload);
  },
  changeSectionCourseGroupIntros({ commit }: any, payload: any) {
    commit('CHANGE_COURSE_GROUP_INTROS', payload);
  },
  changeCourseGroupLadder({ commit }: any, payload: any) {
    commit('CHANGE_COURSE_GROUP_LADDER', payload);
  },
  changeCourseGroupOriginPrice({ commit }: any, payload: any) {
    commit('CHANGE_COURSE_GROUP_ORIGINPRICE', payload);
  },
  changeSelectedSeqNo({ commit }: any, payload: any) {
    commit('CHANGE_SELECTED_SEQNO', payload);
  },
  /********* ********** **********/
  // 修改选择等级
  changeChooseDegree({ commit }: any, chooseDegree: any) {
    commit('CHANGE_CHOOSE_DEGREE', chooseDegree);
  },

  // 修改排行榜
  changeRankList({ commit }: any, list: any) {
    commit('CHANGE_RANK_LIST', list || []);
  },

  // 修改地址上的uid
  changeUrlUid({ commit }: any, uid: string) {
    commit('CHANGE_URL_UID', uid);
  },

  // 修改砍价概率和次数
  changeChanceCount({ commit }: any, payload: any) {
    commit('CHANGE_CHANCE_COUNT', payload);
  },

  // 修改未成团列表开关
  changeUnGroupSwitch({ commit }: any, status: boolean) {
    commit('CHANGE_UNGROUP_SWITCH', status);
  },
  // 修改拼团失败自动取消报名开关
  changeAutoCancel({ commit }: any, status: boolean) {
    commit('CHANGE_AUTO_CANCEL', status);
  },
  // 修改老生参加开关
  changeGroupSwitch({ commit }: any, status: boolean) {
    commit('CHANGE_GROUP_SWITCH', status);
  },

  // 修改上传的活动主图
  changeGroupImageList({ commit }: any, payload: any) {
    commit('CHANGE_GROUP_IMAGE_LIST', payload);
  },
  // 保存奖品列表
  changeOldPrizeList({ commit }: any, payload: any) {
    commit('CHANGE_OLD_PRIZE_LIST', payload);
  },

  // 修改拼团列表
  changeGroupList({ commit }: any, groupList: Array<object>) {
    commit('CHANGE_GROUP_LIST', groupList);
  },

  // 修改开团林团数
  changeGroupNumber({ commit }: any, payload: any) {
    commit('CHANGE_GROUP_NUMBER', payload);
  },

  // 修改团是否满的状态
  changeGroupFullStatus({ commit }: any, status: boolean) {
    commit('CHANGE_GROUP_FULL', status);
  },
  changeShowFooter({ commit }: any, status: boolean) {
    commit('CHANGE_SHOW_FOOTER', status);
  },

  // 修改是否已支付状态
  changeHasPay({ commit }: any, status: boolean) {
    commit('CHANGE_HAS_PAY', status);
  },

  changeCancel({ commit }: any, status: boolean) {
    commit('CHANGE_CANNEL', status);
  },
  changeHasSignIn({ commit }: any, status: boolean) {
    commit('HAS_SIGN_IN', status);
  },
  
  changeShowJoinFooter({ commit }: any, status: boolean) {
    commit('CHANGE_SHOW_JOIN_FOOTER', status);
  },

  changeJoinGroupFlag({ commit }: any, status: boolean) {
    commit('CHANGE_JOIN_GROUP_FLAG', status);
  },

  changeOriginalTitle({ commit }: any, status: string) {
    commit('CHANGE_ORIGINAL_TITLE', status);
  },
  // 修改页面标题
  changeDocumentTitle({ commit }: any, status: string) {
    commit('CHANGE_DOCUMENT_TITLE', status);
  },

  // 修改活动主题
  changeViewBackground({ commit }: any, status: string) {
    commit('CHANGE_VIEW_BACKGROUND', status);
  },

  // 修改二维码图片
  changeContactQrcode({ commit }: any, status: string) {
    commit('CHANGE_CONTACT_QRCODE', status);
  },

  // 修改报名信息设置
  changeSignupItemConfig({ commit }: any, status: string) {
    commit('CHANGE_SIGNUP_ITEM_CONFIG', status);
  },
  // 修改获奖信息
  changeUserAwardInfo({ commit }: any, status: string) {
    commit('CHANGE_USERAWARD_InfO', status);
  },
  // 是否开启弹幕功能
  changeShowBarrage({ commit }: any, status: string) {
    commit('CHANGE_SHOW_BARRAGE', status);
  },
  // 是否开启购买数据展示
  changeShowNum({ commit }: any, status: string) {
    commit('CHANGE_SHOW_NUM', status);
  },
  // 是否开启统计数据展示
  changeShowData({ commit }: any, status: string) {
    commit('CHANGE_SHOW_DATA', status);
  },

  // 是否购买小麦管家
  changeBuyXmMajordomo({ commit }: any, status: string) {
    commit('CHANGE_BUY_XMMAJORDOMO', status);
  },

  changePosterName({ commit }: any, name: string) {
    commit('CHANGE_POSTER_NAME', name);
  },

  changePosterUrl({ commit }: any, url: string) {
    commit('CHANGE_POSTER_URL', url);
  },

  changePosterAvatar({ commit }: any, avatar: string) {
    commit('CHANGE_POSTER_AVATAR', avatar);
  },

  changeShowIWantDo({ commit }: any, status: boolean) {
    commit('CHANGE_SHOW_IWANT_DO', status);
  },

  changeLadderGroup({ commit }: any, ladderGroupList: Array<Ladder>) {
    commit('CHANGE_LADDER_GROUP', ladderGroupList);
  },

  changeHeadReward({ commit }: any, headReward: string) {
    commit('CHANGE_HEAD_REWARD', headReward);
  },

  changeLeftQuota({ commit }: any, leftQuota: number) {
    commit('CHANGE_LEFTQUOTA', leftQuota);
  },

  // 修改他们正在接龙列表
  changeSolitaireingList({ commit }: any, solitaireingList: Array<object>) {
    commit('CHANGE_SOLITAIREING_LIST', solitaireingList);
  },
  changeHasPaidNumber({ commit }: any, hasPaidNumber: number) {
    commit('CHANGE_HASPAID_NUMBER', hasPaidNumber);
  },

  // 活动素材中心是否已经开启或者保存过
  changeMaterialStatus({ commit }: any, status: boolean) {
    commit('CHANGE_MATERIAL_STATUA', status);
  },

  // 切换短信验证
  switchSMSVerify({ commit }: any, status: boolean) {
    commit('SWITCH_SMS_VERIFY', status);
  },

  // 切换学员报名参与开关
  switchPotentialJoin({ commit }: any, status: boolean) {
    commit('SWITCH_PONTENTIAL_JOIN', status);
  },

  changeInstSMSVerify({ commit }: any, status: boolean) {
    commit('CHANGE_INSTSMS_VERIFY', status);
  },

  // 获取机构剩余短信数目
  changeSMSRemainNumber({ commit }: any, smsRemainNumber: number) {
    commit('CHANGE_SMS_REMAIN_NUMBER', smsRemainNumber);
  },
  changeBargainRank({ commit }: any, currentRank: number) {
    commit('CHANGE_BARGAIN_RANK', currentRank);
  },
  changeBargainPrice({ commit }: any, currentPrice: number) {
    commit('CHANGE_BARGAIN_PRICE', currentPrice);
  },
  changeBargainTime({ commit }: any, currentTime: number) {
    commit('CHANGE_BARGAIN_TIME', currentTime);
  },
  changePayEditModal({ commit }: any, showPayEditModal: boolean) {
    commit('CHANGE_PAY_EDIT_MODAL', showPayEditModal);
  },
  changeInValidModal({ commit }: any, showInValidModal: boolean) {
    commit('CHANGE_INVALID_MODAL', showInValidModal);
  },
  changeSelectedCardIndex({ commit }: any, selectedCardIndex: boolean) {
    commit('CHANGE_SELECTED_CARD_INDEX', selectedCardIndex);
  },
  changeGachaLoading({ commit }: any, gachaLoading: boolean) {
    commit('CHANGE_GACHA_LOADING', gachaLoading);
  },
  changeGachaStart({ commit }: any, gachaStart: boolean) {
    commit('CHANGE_GACHA_START', gachaStart);
  },
  changeDetailLoaded({ commit }: any, detailLoaded: boolean) {
    commit('CHANGE_DETAIL_LOADED', detailLoaded);
  },
  showWesiteBtn({ commit }: any, showWesiteBtn: boolean) {
    commit('CHANGE_SHOW_WESITEBTN', showWesiteBtn);
  },
  changeAvatar({ commit }: any, avatar: boolean) {
    commit('CHANGE_AVATAR', avatar);
  },
  changeNickname({ commit }: any, nickname: boolean) {
    commit('CHANGE_NICKNAME', nickname);
  },
  changeDistributeOrderCreateTime({ commit }: any, distributeOrderCreateTime: number) {
    commit('CHANGE_DISTRIBUTE_ORDER_CREATETIME', distributeOrderCreateTime);
  },
  changeMyReward({ commit }: any, myReward: number) {
    commit('CHANGE_MY_REWARD', myReward);
  },
  changeDistributePurchaseList({ commit }: any, distributePurchaseList: Array<object>) {
    commit('CHANGE_DISTRIBUTE_PURCHASE_LIST', distributePurchaseList);
  },
  changeDistributeTradeId({ commit }: any, distributeTradeId: string) {
    commit('CHANGE_DISTRIBUTE_TRADE_ID', distributeTradeId);
  },
  changeDistributeTabFixed({ commit }: any, distributeTabFixed: string) {
    commit('CHANGE_DISTRIBUTE_TAB_FIXED', distributeTabFixed);
  },
  changeInstIds({ commit }: any, instIds: string) {
    commit('CHANGE_INST_IDS', instIds);
  },
  changeInstList({ commit }: any, instList: string) {
    commit('CHANGE_INST_LIST', instList);
  },
  changeInstNameNot({ commit }: any, instNameNot: string) {
    commit('CHANGE_INST_NAME_NOT', instNameNot);
  },
  changeInstNameFew({ commit }: any, instNameFew: string) {
    commit('CHANGE_INST_NAME_FEW', instNameFew);
  },
  changeInstNameZero({ commit }: any, instNameZero: string) {
    commit('CHANGE_INST_NAME_ZERO', instNameZero);
  },
  changeLeadersInstId({ commit }: any, leadersInstId: string) {
    commit('CHANGE_LEADERS_INST_ID', leadersInstId);
  },
  changePayInstId({ commit }: any, payInstId: string) {
    commit('CHANGE_PAY_INST_ID', payInstId);
  }
};

export default actions;
